import React, { Component } from 'react';
import './FooterBar.css';
import {IoChatbubblesOutline} from "react-icons/io5";
import {
  Navbar,
  Nav
} from 'reactstrap';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { isMobile } from '../../utils/deviceInfo';
import trendingImg from '../../assets/trending_footer.svg';
import trendingActiveImg from '../../assets/trending_active.svg';
import privacyIconImg from '../../assets/privacy_footer_icon.svg';
import privacyActiveIconImg from '../../assets/privacy_footer_active.svg';
import addIconImg from '../../assets/add_stories.svg';
import daniIcon from '../../assets/dani_icon_2.png';
import addIconActiveImg from '../../assets/add_stories_active.svg';
import groupActiveImg from '../../assets/group_active.svg';
import groupImg from '../../assets/group.svg';
import userImg from '../../assets/phone_book.svg';
import myStoriesImg from '../../assets/my_stories.svg';
import myStoriesActiveImg from '../../assets/my_stories_active.svg';

class FooterBar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { path } = this.props.match
    const { search } = this.props.location
    const isMyStories = path.includes("/stories/me") || search.includes("?me")
    const isTrending = path.includes("/stories/trending")
    const isAnnouncements = path.includes("/announcements")
    const isTypes = path.includes("stories/types")
    const isStories = path.includes("/stories") && !isMyStories && !isTrending && !isTypes
    const isUsers = path.includes("/users")


    return (
      <Navbar expand="md" fixed="bottom" role="navigation"
      className="footer-navigation-bg mobile-bottom-bar">
        <div onClick={() => this.props.history.push(`/home/stories`)} className="storyCategoryTrending footer-link">
          <img className="" style={{height:'32px' }} src={isStories ? groupActiveImg : groupImg} />
        </div>
        <div onClick={() => this.props.history.push(`/home/stories/trending`)} className="storyCategoryTrending footer-link">
          <img className="" style={{height:'32px' }} src={isTrending ? trendingActiveImg : trendingImg} />
        </div>
        <div onClick={() => this.props.history.push(`/home/stories/types`)} className="storyCategoryTrending footer-link">
          <img className=""  style={{height:'32px' }} src={isTypes ? addIconActiveImg : addIconImg} />
        </div>
        <div onClick={() => this.props.history.push(`/home/expand/dani`)} className="storyCategoryTrending footer-link">
          {/* <IoChatbubblesOutline size="32px" /> */}
          <img className=""  style={{height:'32px' }} src={daniIcon} />
        </div>
         {/* <div onClick={() => this.props.history.push(`/home/users`)} className="storyCategoryTrending footer-link">
        <img className="" style={{height:'32px' }} src={isUsers ? privacyActiveIconImg : privacyIconImg}/>
        </div> */}
        <div onClick={() => this.props.history.push(`/home/stories/me`)} className="storyCategoryTrending footer-link">
          <img className=""   style={{height:'32px' }} src={isMyStories ? myStoriesActiveImg : myStoriesImg} />
        </div>

      </Navbar>
    )
  }
}

const mapDispatchToProps = dispatch => {
	return {}
}

export default connect(null, mapDispatchToProps)(withRouter(FooterBar));
